import { render, staticRenderFns } from "./collectionVideo.vue?vue&type=template&id=79d22ae3&scoped=true"
import script from "./collectionVideo.vue?vue&type=script&lang=js"
export * from "./collectionVideo.vue?vue&type=script&lang=js"
import style0 from "./collectionVideo.vue?vue&type=style&index=0&id=79d22ae3&prod&scoped=true&lang=css"
import style1 from "./collectionVideo.vue?vue&type=style&index=1&id=79d22ae3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d22ae3",
  null
  
)

export default component.exports